/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ForgeProjectEntrypointComponent = EntryPointComponent<
	{},
	{},
	{},
	{
		match: RouteContext['match'];
	}
>;

export const forgeProjectEntrypoint: EntryPoint<
	ForgeProjectEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<ForgeProjectEntrypointComponent>(
		/* webpackChunkName: "async-forge-project-entrypoint" */ './ForgeProjectPageShellWithAnalyticsMemo.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		extraProps: {
			match: context.match,
		},
	}),
});
